export const URLS = Object.freeze({
  BO_V1: process.env.BO_V1 || 'https://admin.p.gtrsuite.com',
  BO_V3: process.env.BO_V3 || 'https://local.gtrsuite.com:9001',
  SSO: process.env.SSO || 'https://local.gtrsuite.com:9003',
  LOCAL_GOOGLE: 'https://local.google.com',
  USER_EXPRESS: process.env.USER_EXPRESS || 'https://preprod--hours-moderation.netlify.app',
  SUPER_ADMIN: process.env.SUPER_ADMIN || 'https://brain.p.gtrsuite.com',
  RADAR: process.env.RADAR || 'https://preprod--gator-radar.netlify.app',
})
